/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { setError } from "../../../../errorHandler";

const apiClient = () => {
  // Create instance
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    // method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Set the AUTH token for any request
  instance.interceptors.request.use(
    (config: any) => {
      // extract token from cookies
      const tokenSession = window.localStorage.getItem("token");
      config.headers.Authorization = tokenSession ? `Bearer ${tokenSession}` : "";
      config.headers["correlation-id"] = uuidv4();
      return config;
    },
    (error) => {
      setError(error);
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        window.localStorage.removeItem("token");
        window.location.assign("/");
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export default apiClient();
